/*
 * KPS Hero - before/after slider (banner v2, phones only).
 *
 * The script owns exactly one number: the divider position, 0-100. It writes it
 * to the --pos custom property on the frame and mirrors it into aria-valuenow.
 * Everything visible - the AFTER photo's clip, the divider line, the grip and
 * both labels - is positioned from that one property in CSS, so the handle and
 * the seam cannot drift apart at any position. There is no second calculation
 * to disagree with the first.
 *
 * Pointer Events with setPointerCapture, so one code path covers touch, pen and
 * mouse, and a drag that leaves the frame keeps tracking. Vertical scrolling is
 * left to the browser via touch-action: pan-y in the CSS - the script never
 * calls preventDefault on a pointer event, which is what would kill the scroll.
 *
 * Above 767px the section renders as it always has, so every handler bails out
 * unless the phone media query matches.
 */
(function () {
  'use strict';

  var MQ = '(max-width: 767px)';
  var START = 50;

  function setup(frame) {
    if (frame.kpsBaReady) return;
    frame.kpsBaReady = true;

    var grip = frame.querySelector('[data-kps-ba-grip]');
    var mq = window.matchMedia(MQ);
    var pos = START;
    var dragging = false;

    function apply(next) {
      pos = Math.max(0, Math.min(100, next));
      frame.style.setProperty('--pos', pos + '%');
      if (grip) grip.setAttribute('aria-valuenow', String(Math.round(pos)));
    }

    function fromPointer(event) {
      var box = frame.getBoundingClientRect();
      if (!box.width) return;
      apply(((event.clientX - box.left) / box.width) * 100);
    }

    function stop() {
      if (!dragging) return;
      dragging = false;
      delete frame.dataset.dragging;
    }

    frame.addEventListener('pointerdown', function (event) {
      if (!mq.matches) return;
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      dragging = true;
      // Drives the CSS that drops the transition, so the divider tracks the
      // finger exactly instead of easing behind it.
      frame.dataset.dragging = 'true';
      try {
        frame.setPointerCapture(event.pointerId);
      } catch (err) {
        /* capture is an optimisation; the drag still works without it */
      }
      fromPointer(event);
    });

    frame.addEventListener('pointermove', function (event) {
      if (!dragging || !mq.matches) return;
      fromPointer(event);
    });

    frame.addEventListener('pointerup', stop);
    frame.addEventListener('pointercancel', stop);
    frame.addEventListener('lostpointercapture', stop);

    if (grip) {
      grip.addEventListener('keydown', function (event) {
        var step = event.shiftKey ? 10 : 1;
        var next = null;

        switch (event.key) {
          case 'ArrowLeft':
          case 'ArrowDown':
            next = pos - step;
            break;
          case 'ArrowRight':
          case 'ArrowUp':
            next = pos + step;
            break;
          case 'PageDown':
            next = pos - 10;
            break;
          case 'PageUp':
            next = pos + 10;
            break;
          case 'Home':
            next = 0;
            break;
          case 'End':
            next = 100;
            break;
          default:
            return;
        }

        // Only swallow the keys the slider actually consumes, so Tab, Enter and
        // the rest of the page keep working.
        event.preventDefault();
        apply(next);
      });

      // A click on the grip must not fire the drag twice or submit anything.
      grip.addEventListener('click', function (event) {
        event.preventDefault();
      });
    }

    apply(START);
  }

  function init(root) {
    var scope = root || document;
    var frames = scope.querySelectorAll('[data-kps-ba]');
    for (var i = 0; i < frames.length; i++) setup(frames[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Theme editor: the section is replaced wholesale on every settings change.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
